/**
* @author Edgar Escobedo
* @description return date in format DD de MMM del YYYY ej: 28 de junio del 2023
* @updatedDate 04-07-2023
* @param {Number} date 
* @returns {date}
*/

import moment from "moment"

const dateDayMonthCompleteAndYearComplete = (date) => {
  let split = date.split('/')
  let day = (split && split.length > 0) ? split[0] : ''
  let month = (split && split.length > 0) ? split[1] : ''
  let year = (split && split.length > 0) ? split[2] : ''

  let monthString = ''
  let yearString = `${year}`

  if (month === '01') {
    monthString = 'enero'
  } else if (month === '02') {
    monthString = 'febrero'
  } else if (month === '03') {
    monthString = 'marzo'
  } else if (month === '04') {
    monthString = 'abril'
  } else if (month === '05') {
    monthString = 'mayo'
  } else if (month === '06') {
    monthString = 'junio'
  } else if (month === '07') {
    monthString = 'julio'
  } else if (month === '08') {
    monthString = 'agosto'
  } else if (month === '09') {
    monthString = 'septiembre'
  } else if (month === '10') {
    monthString = 'octubre'
  } else if (month === '11') {
    monthString = 'noviembre'
  } else if (month === '12') {
    monthString = 'diciembre'
  }
  let dateResult = `${day} de ${monthString} del ${yearString}`
  return dateResult
}


/**
* @author Edgar Escobedo
* @description return date in format DD/MMM/YYYY ej: 28/Agosto/2023 
* @updatedDate 05-07-2023
* @param {Number} date 
* @returns {date}
*/
const limitExpirationDateInContract = (date) => {
  moment.locale("es");
  let yearStartContractL = date.split("/")[2];
  let monthStartContractL = date.split("/")[1];
  let dayStartContractL = date.split("/")[0];
  let dateLimit = dayStartContractL +
    "/" +
    moment(monthStartContractL).format("MMM").toLowerCase() +
    "/" +
    yearStartContractL
  dateLimit = dateLimit.replaceAll(".", "")
  return dateLimit
}


/**
* @author Edgar Escobedo
* @description return date in format DD/MMM/YYYY ej: 28/Agosto/2023 
* @updatedDate 05-07-2023
* @param {Number} date 
* @returns {date}
*/
const dateInDialogChanceDate = (date) => {
  moment.locale("es");
  let [day, month, year] = date.split("/");
  let dateConvert = new Date(+year, +month - 1, +day) > new Date()
    ? new Date(+year, +month - 1, +day)
    : new Date()
  return dateConvert
}

/**
* @author Edgar Escobedo
* @description convert a date from BD to Show in date
* @updatedDate 09-11-2023
* @param {Number} date 
* @returns {date}
*/

const convertDateBDToShow = (date) => {
  let dateParse = new Date(date.replace(/-/g, '\/')).toLocaleDateString('en-us', { year: "numeric", month: "numeric", day: "numeric" })
  let day = (dateParse) ? dateParse.split('/')[1] : ''
  let month = (dateParse) ? dateParse.split('/')[0] : ''
  let year = (dateParse) ? dateParse.split('/')[2] : ''
  let completeDate = year + '/' + month + '/' + day
  let dateConvert = new Date(completeDate)

  return dateConvert

}

/**
* @author Edgar Escobedo
* @description convert some string dates in dates
* @updatedDate 09-11-2023
* @param {Number} date 
* @returns {date}
*/
const convertStringInDates = (date) => {
  let dateComplete
  let dateReplace
  let dateSplit0
  let dateSplit1
  let dateSplit2
  let format

  if (date.includes('-')) {
    dateReplace = date.replace(/-/g, '\/')
    dateSplit0 = dateReplace.split('/')[0]
    dateSplit1 = dateReplace.split('/')[1]
    dateSplit2 = dateReplace.split('/')[2]

    let monthNumber = (dateSplit1) ? Number(dateSplit1) : null
    if (dateSplit0.length === 4 && monthNumber && Number.isInteger(monthNumber)) {
      dateComplete = `${dateSplit0}/${dateSplit1}/${dateSplit2}`
      format = 'yyyy-MM-dd'
    }

    if (dateSplit0.length === 2 && monthNumber && Number.isInteger(monthNumber)) {
      dateComplete = `${dateSplit2}/${dateSplit1}/${dateSplit0}`
      format = 'dd-MM-yyyy'
    }
  }

  if (date.includes('/')) {
    dateSplit0 = date.split('/')[0]
    dateSplit1 = date.split('/')[1]
    dateSplit2 = date.split('/')[2]
    if (dateSplit0.length === 4) {
      dateComplete = `${dateSplit0}/${dateSplit1}/${dateSplit2}`
      format = 'yyyy/MM/dd'
    }

    if (dateSplit0.length === 2) {
      dateComplete = `${dateSplit2}/${dateSplit1}/${dateSplit0}`
      format = 'dd/MM/yyyy'
    }
  }

  if (dateSplit1 && dateSplit1.length === 3) {
    if (dateSplit1 === 'Ene' || dateSplit1 === 'ene' || dateSplit1 === 'Enero' || dateSplit1 === 'enero') {
      dateSplit1 = '01'
    } else if (dateSplit1 === 'Feb' || dateSplit1 === 'feb' || dateSplit1 === 'Febrero' || dateSplit1 === 'febrero') {
      dateSplit1 = '02'
    } else if (dateSplit1 === 'Mar' || dateSplit1 === 'mar' || dateSplit1 === 'Marzo' || dateSplit1 === 'marzo') {
      dateSplit1 = '03'
    } else if (dateSplit1 === 'Abr' || dateSplit1 === 'abr' || dateSplit1 === 'Abril' || dateSplit1 === 'abril') {
      dateSplit1 = '04'
    } else if (dateSplit1 === 'May' || dateSplit1 === 'may' || dateSplit1 === 'Mayo' || dateSplit1 === 'mmayo') {
      dateSplit1 = '05'
    } else if (dateSplit1 === 'Jun' || dateSplit1 === 'jun' || dateSplit1 === 'Junio' || dateSplit1 === 'junio') {
      dateSplit1 = '06'
    } else if (dateSplit1 === 'Jul' || dateSplit1 === 'jul' || dateSplit1 === 'Julio' || dateSplit1 === 'julio') {
      dateSplit1 = '07'
    } else if (dateSplit1 === 'Ago' || dateSplit1 === 'ago' || dateSplit1 === 'Agosto' || dateSplit1 === 'agosto') {
      dateSplit1 = '08'
    } else if (dateSplit1 === 'Sep' || dateSplit1 === 'sep' || dateSplit1 === 'Septiembre' || dateSplit1 === 'septiembre') {
      dateSplit1 = '09'
    } else if (dateSplit1 === 'Oct' || dateSplit1 === 'oct' || dateSplit1 === 'Octubre' || dateSplit1 === 'octubre') {
      dateSplit1 = '10'
    } else if (dateSplit1 === 'Nov' || dateSplit1 === 'nov' || dateSplit1 === 'Noviembre' || dateSplit1 === 'noviembre') {
      dateSplit1 = '11'
    } else if (dateSplit1 === 'Dic' || dateSplit1 === 'dic' || dateSplit1 === 'Diciembre' || dateSplit1 === 'diciembre') {
      dateSplit1 = '12'
    }

    if (dateSplit0.length === 2) {
      dateComplete = `${dateSplit2}/${dateSplit1}/${dateSplit0}`
    }

    if (dateSplit0.length === 4) {
      dateComplete = `${dateSplit0}/${dateSplit1}/${dateSplit2}`
    }

  }

  if (date.includes('de') || date.includes('del')) {
    let splitDate = date.split(' ')
    dateSplit0 = splitDate[0]
    dateSplit1 = splitDate[2]
    dateSplit2 = splitDate[4]
    if (!Number(dateSplit2)) {
      let year = splitDate.find(split => split.length === 4)
      dateSplit2 = (year) ? year : dateSplit2
    }
    if (dateSplit1 === 'Ene' || dateSplit1 === 'ene' || dateSplit1 === 'Enero' || dateSplit1 === 'enero') {
      dateSplit1 = '01'
    } else if (dateSplit1 === 'Feb' || dateSplit1 === 'feb' || dateSplit1 === 'Febrero' || dateSplit1 === 'febrero') {
      dateSplit1 = '02'
    } else if (dateSplit1 === 'Mar' || dateSplit1 === 'mar' || dateSplit1 === 'Marzo' || dateSplit1 === 'marzo') {
      dateSplit1 = '03'
    } else if (dateSplit1 === 'Abr' || dateSplit1 === 'abr' || dateSplit1 === 'Abril' || dateSplit1 === 'abril') {
      dateSplit1 = '04'
    } else if (dateSplit1 === 'May' || dateSplit1 === 'may' || dateSplit1 === 'Mayo' || dateSplit1 === 'mmayo') {
      dateSplit1 = '05'
    } else if (dateSplit1 === 'Jun' || dateSplit1 === 'jun' || dateSplit1 === 'Junio' || dateSplit1 === 'junio') {
      dateSplit1 = '06'
    } else if (dateSplit1 === 'Jul' || dateSplit1 === 'jul' || dateSplit1 === 'Julio' || dateSplit1 === 'julio') {
      dateSplit1 = '07'
    } else if (dateSplit1 === 'Ago' || dateSplit1 === 'ago' || dateSplit1 === 'Agosto' || dateSplit1 === 'agosto') {
      dateSplit1 = '08'
    } else if (dateSplit1 === 'Sep' || dateSplit1 === 'sep' || dateSplit1 === 'Septiembre' || dateSplit1 === 'septiembre') {
      dateSplit1 = '09'
    } else if (dateSplit1 === 'Oct' || dateSplit1 === 'oct' || dateSplit1 === 'Octubre' || dateSplit1 === 'octubre') {
      dateSplit1 = '10'
    } else if (dateSplit1 === 'Nov' || dateSplit1 === 'nov' || dateSplit1 === 'Noviembre' || dateSplit1 === 'noviembre') {
      dateSplit1 = '11'
    } else if (dateSplit1 === 'Dic' || dateSplit1 === 'dic' || dateSplit1 === 'Diciembre' || dateSplit1 === 'diciembre') {
      dateSplit1 = '12'
    }
    dateComplete = `${dateSplit2}/${dateSplit1}/${dateSplit0}`

    format = {
      day: 'numeric',
      month: "short",
      year: "numeric"
    }
  }

  if (!dateComplete || !dateSplit0 || isNaN(!dateSplit0) || !dateSplit1 || isNaN(!dateSplit1) || !dateSplit2 || isNaN(!dateSplit2)) return null
  let dateConvert = new Date(dateComplete)
  if (isNaN(dateConvert)) return null

  let data = {
    date: dateConvert,
    format
  }

  return data
}

/**
 * @author Edgar Escobedo
 * @description Convert a date to standar date.
 * @updatedDate 21/11/2024
 * @typedef {Object} Props
 * @property {String} date Se convierte la fecha a string y se envia con el formato requerido
 * ```js
 * let date = 2023-10-25
 * @property {String} language Es el lenguaje que tiene el sitema para convrtir correctamente la fecha
 *  * ```js
 * let language = 'es'
 * @return {JSX.Element} 
 */
const convertToStandarDate = (date, language) => {
  moment.locale(language || 'es');
  let momentDate = moment(date)
  let convertDate = momentDate.format("DD/MMM/YYYY")
  let dateStandar = convertDate.replaceAll('.', "")
  dateStandar = dateStandar.toLocaleLowerCase()
  return dateStandar
}

export { dateDayMonthCompleteAndYearComplete, limitExpirationDateInContract, dateInDialogChanceDate, convertDateBDToShow, convertStringInDates, convertToStandarDate }